import { useMsal } from "@azure/msal-react";

import { useUser } from "@/hooks/useUser";

export function TopBar() {
  const { instance } = useMsal();
  const { data: user } = useUser();

  return (
    <header className="flex items-center justify-between border-b border-gray-200 bg-white px-6 py-3">
      <h1 className="font-display text-base font-semibold text-ink">ASO</h1>
      <div className="flex items-center gap-4 text-sm">
        {user ? (
          <span className="text-ink-muted">
            {user.nome} · <span className="font-medium text-anarosa">{user.papel}</span>
          </span>
        ) : null}
        <button
          className="btn-secondary"
          onClick={() => instance.logoutRedirect()}
        >
          Sair
        </button>
      </div>
    </header>
  );
}
